(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apx-article"]) return;
  try {
    
  (() => {
    const article = document.querySelector('.apx-article');
    if (!article) return;
    const body = article.querySelector('.apx-article__body');
    const toc = article.querySelector('.apx-article__toc');
    const bar = document.querySelector('.apx-article__progress span');

    // Contents list from the article's H2s
    const headings = [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim());
    if (headings.length >= 2) {
      const list = toc.querySelector('ol');
      const used = new Set();
      headings.forEach((h, i) => {
        let id = h.id || h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `section-${i}`;
        while (used.has(id)) id += '-' + i;
        used.add(id);
        h.id = id;
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${id}`;
        a.textContent = h.textContent.trim();
        li.append(a);
        list.append(li);
      });
      toc.hidden = false;
      if (window.matchMedia('(min-width: 990px)').matches) toc.open = true;

      toc.addEventListener('click', (e) => {
        const link = e.target.closest('a');
        if (!link) return;
        e.preventDefault();
        const target = document.getElementById(link.hash.slice(1));
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', link.hash);
        if (!window.matchMedia('(min-width: 990px)').matches) toc.open = false;
      });

      const links = [...list.querySelectorAll('a')];
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((l) => l.toggleAttribute('aria-current', l.hash === `#${entry.target.id}`));
          });
        },
        { rootMargin: '0px 0px -70% 0px' }
      );
      headings.forEach((h) => observer.observe(h));
    }

    // Reading progress
    const update = () => {
      const rect = body.getBoundingClientRect();
      const total = rect.height - window.innerHeight * 0.6;
      const progress = Math.min(1, Math.max(0, -rect.top / (total || 1)));
      if (bar) bar.style.transform = `scaleX(${progress})`;
    };
    document.addEventListener('scroll', update, { passive: true });
    update();

    // Copy link
    article.addEventListener('click', async (e) => {
      const button = e.target.closest('[data-copy]');
      if (!button) return;
      const status = article.querySelector('.apx-article__copied');
      try {
        await navigator.clipboard.writeText(button.dataset.copy);
        status.textContent = 'Link copied';
      } catch {
        status.textContent = button.dataset.copy;
      }
      clearTimeout(status._t);
      status._t = setTimeout(() => (status.textContent = ''), 2200);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apx-blog"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('.apx-blog__chip');
    if (!chip) return;
    const root = chip.closest('.apx-blog');
    const tag = chip.dataset.tag;
    root.querySelectorAll('.apx-blog__chip').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
    let shown = 0;
    root.querySelectorAll('.apx-blog__item').forEach((item) => {
      const match = !tag || item.dataset.tags.includes(` ${tag} `);
      item.hidden = !match;
      if (match) shown++;
    });
    root.classList.toggle('apx-blog--filtered', Boolean(tag));
    const none = root.querySelector('.apx-blog__none');
    if (none) none.hidden = shown > 0;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apx-collection"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-apx-sort]');
    if (!select) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apx-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apx-faq')) {
    customElements.define(
      'apx-faq',
      class extends HTMLElement {
        connectedCallback() {
          // One answer open at a time
          this.addEventListener(
            'toggle',
            (event) => {
              const opened = event.target;
              if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
              this.querySelectorAll('.apx-faq__item[open]').forEach((d) => d !== opened && (d.open = false));
            },
            true
          );
          this.addEventListener('click', (event) => {
            const tab = event.target.closest('.apx-faq__tab');
            if (!tab) return;
            const group = tab.dataset.group;
            this.querySelectorAll('.apx-faq__tab').forEach((t) => t.setAttribute('aria-pressed', String(t === tab)));
            this.querySelectorAll('.apx-faq__item').forEach((item) => {
              item.hidden = Boolean(group) && item.dataset.group !== group;
              if (item.hidden) item.open = false;
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apx-featured"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apx-fp-gallery')) {
    customElements.define(
      'apx-fp-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const thumb = event.target.closest('[data-go]');
            if (!thumb) return;
            const index = thumb.dataset.go;
            this.querySelectorAll('.apx-fp__slide').forEach((s) => s.classList.toggle('is-active', s.dataset.index === index));
            this.querySelectorAll('[data-go]').forEach((t) => t.setAttribute('aria-selected', String(t === thumb)));
          });
        }
      }
    );
  }

  // Add the product and (when ticked) the free gift together, then open the cart page.
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-apx-fp-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('.apx-fp__add');
    const error = form.querySelector('.apx-fp__error');
    const items = [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }];
    const gift = form.querySelector('[data-apx-gift]');
    if (gift?.checked) items.push({ id: Number(gift.value), quantity: 1 });
    button.disabled = true;
    error.hidden = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error((await response.json().catch(() => ({}))).description || 'Could not add to cart.');
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch (e) {
      error.textContent = e.message;
      error.hidden = false;
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apx-review-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apx-review-columns')) {
    customElements.define(
      'apx-review-columns',
      class extends HTMLElement {
        connectedCallback() {
          this.cards = [...this.querySelectorAll('.apx-rw__source > .apx-rw__card')];
          this.cols = this.querySelector('.apx-rw__cols');
          this.query = window.matchMedia('(min-width: 990px)');
          this.build = this.build.bind(this);
          this.query.addEventListener('change', this.build);
          this.build();

          this.addEventListener('click', (event) => {
            const button = event.target.closest('.apx-rw__play');
            if (!button) return;
            const video = button.parentElement.querySelector('video');
            if (!video) return;
            this.querySelectorAll('video').forEach((v) => v !== video && v.pause());
            if (video.paused) {
              video.play();
              button.classList.add('is-playing');
              this.classList.add('is-paused');
            } else {
              video.pause();
              button.classList.remove('is-playing');
              this.classList.remove('is-paused');
            }
          });
        }

        build() {
          const count = this.query.matches ? 4 : 2;
          const columns = Array.from({ length: count }, () => []);
          this.cards.forEach((card, i) => columns[i % count].push(card));
          this.cols.replaceChildren(
            ...columns.map((list, c) => {
              const col = document.createElement('div');
              col.className = `apx-rw__col apx-rw__col--${c % 2 ? 'down' : 'up'}`;
              col.style.setProperty('--rw-items', String(Math.max(list.length, 1)));
              const track = document.createElement('div');
              track.className = 'apx-rw__track';
              // Two copies so the loop is seamless; the copy is hidden from screen readers.
              [false, true].forEach((copy) => {
                const group = document.createElement('div');
                group.className = 'apx-rw__group';
                if (copy) group.setAttribute('aria-hidden', 'true');
                list.forEach((card) => {
                  const clone = card.cloneNode(true);
                  if (copy) clone.querySelectorAll('button, a').forEach((el) => el.setAttribute('tabindex', '-1'));
                  group.append(clone);
                });
                track.append(group);
              });
              col.append(track);
              return col;
            })
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apx-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apx-steps-slider')) {
    class ApxStepsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        const dots = this.querySelector('[data-dots]');
        if (!this.track || this.slides.length < 2) {
          this.next?.setAttribute('hidden', '');
          return;
        }

        this.dots = this.slides.map(() => {
          const dot = document.createElement('span');
          dot.className = 'apx-steps__dot';
          dots?.append(dot);
          return dot;
        });

        this.prev?.addEventListener('click', () => this.go(this.index - 1));
        this.next?.addEventListener('click', () => this.go(this.index + 1));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, { passive: true });
        this.update();
      }

      get index() {
        return Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
      }

      go(i) {
        const target = Math.max(0, Math.min(i, this.slides.length - 1));
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
      }

      update() {
        const i = this.index;
        this.dots.forEach((dot, n) => dot.classList.toggle('is-active', n === i));
        this.prev.hidden = i === 0;
        this.next.hidden = i >= this.slides.length - 1;
      }
    }
    customElements.define('apx-steps-slider', ApxStepsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apx-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apx-story-carousel')) {
    customElements.define(
      'apx-story-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.apx-st__track');
          this.slides = [...this.querySelectorAll('.apx-st__slide')];
          this.dots = [...this.querySelectorAll('.apx-st__dot')];
          this.quote = this.querySelector('.apx-st__quote-inner');
          this.current = -1;
          const observer = new IntersectionObserver(
            (entries) => {
              const best = entries.filter((e) => e.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
              if (best) this.select(Number(best.target.dataset.index), false);
            },
            { root: this.track, threshold: [0.6, 0.9] }
          );
          this.slides.forEach((s) => observer.observe(s));
          this.dots.forEach((d) => d.addEventListener('click', () => this.select(Number(d.dataset.go), true)));
          this.slides.forEach((s) =>
            s.addEventListener('click', (e) => {
              if (!e.target.closest('.apx-st__play')) this.select(Number(s.dataset.index), true);
            })
          );
          this.select(0, false);
        }

        select(index, scroll) {
          if (index !== this.current) {
            this.current = index;
            this.slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
            this.dots.forEach((d, i) => d.setAttribute('aria-selected', String(i === index)));
            const tpl = this.slides[index].querySelector('template');
            this.quote.replaceChildren(tpl.content.cloneNode(true));
            this.quote.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 350, easing: 'ease-out' });
          }
          if (scroll) this.slides[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }
    );
  }

  if (!customElements.get('apx-review-wall')) {
    customElements.define(
      'apx-review-wall',
      class extends HTMLElement {
        connectedCallback() {
          const more = this.querySelector('.apx-st__more');
          more?.addEventListener('click', () => {
            const hidden = [...this.querySelectorAll('.apx-st__card.is-hidden')];
            hidden.slice(0, Number(this.dataset.step) || 8).forEach((c) => c.classList.remove('is-hidden'));
            if (hidden.length <= (Number(this.dataset.step) || 8)) more.remove();
          });
        }
      }
    );
  }

  // Tap-to-play for story and review videos
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.apx-st__play');
    if (!button) return;
    const video = button.parentElement.querySelector('video');
    if (!video) return;
    document.querySelectorAll('.apx-st video').forEach((v) => v !== video && v.pause());
    if (video.paused) {
      video.muted = false;
      video.play();
      button.classList.add('is-playing');
    } else {
      video.pause();
      button.classList.remove('is-playing');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apx-therapy-rows"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apx-therapy-rows')) {
    // Only play the videos that are on screen
    class ApxTherapyRows extends HTMLElement {
      connectedCallback() {
        const videos = [...this.querySelectorAll('video')];
        if (!videos.length || !('IntersectionObserver' in window)) return;
        this.io = new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            if (isIntersecting) target.play?.().catch(() => {});
            else target.pause?.();
          });
        }, { threshold: 0.25 });
        videos.forEach((video) => {
          video.muted = true;
          this.io.observe(video);
        });
      }

      disconnectedCallback() {
        this.io?.disconnect();
      }
    }
    customElements.define('apx-therapy-rows', ApxTherapyRows);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
